Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "AboutEditor2205518562",
  {"root":"AboutEditor2205518562--root"},
  "",
  12,
  "AboutEditor2205518562"
);

